import {CardBody, CardTitle, Col, Row} from "reactstrap";
import { MotionCard } from "../../Core/MotionStrap";
import CardType from "../../../lib/Core/Backend/Controllers/CardType";
import {motion} from "framer-motion";
import React from "react";
import Utils from "lib/Utils/Utils";

const BrandCard = (props) =>
{
	const mainCard = {
		animate: {
			transition: {
				delayChildren: 0,
				duration: 0.3,
				ease: "easeOut"
			}
		}
	};

	const flipCard = {
		initial: {
			rotateY: "0deg", transition: {
				duration: 0.3,
				ease: "easeOut"
			}
		}, animate: {
			rotateY: "180deg", transition: {
				duration: 0.3,
				ease: "easeOut"
			}
		}
	};
	const orderCard = {
		initial: {zIndex: 0}, animate: {zIndex: -2,}
	};
	const cardTypeCtl = new CardType(props.token);
	return (
		<motion.div initial="initial" whileHover="animate" variants={mainCard}>
			<motion.div variants={flipCard} style={{position: 'relative'}}>
				<MotionCard variants={orderCard} className="card-stats mb-4 mb-xl-0">
					<CardBody>
						<Row>
							<div className="col">
								<CardTitle tag="h5" className="text-uppercase text-muted mb-0">
									{props.brandName}
								</CardTitle>
							</div>
							<Col className="col-auto">
								<div className="icon icon-shape text-white overflow-hidden" style={{width: "9rem", height: "9rem", borderRadius: "0px"}}>
									<img style={{maxWidth: "8rem", maxHeight: "8rem"}} src={props.logoURL} alt={props.brandName}/>
								</div>
							</Col>
						</Row>
						<p className="mt-3 mb-0 text-muted text-sm">
							<span className="text-success mr-2">
								{props.discount > 0 &&
									<>
										<i className="fa fa-arrow-down"/>
										{Utils.percentFormat(props.discount/100)}
									</>
								}
							</span><span className="pl-2 text-nowrap">
								{props.fee > 0 &&
									<>
										Fee: ${props.fee}
									</>
								}
							</span>
						</p>
					</CardBody>
				</MotionCard>
				<div className="card-stats mb-4 mb-xl-0"
					 style={{position: 'absolute', top: '0px', left: '15px', width: 'calc(100% - 30px)', height: '100%', transform: 'rotateY(180deg)', zIndex: -1, overflowX: 'hidden', overflowY: 'auto', backgroundColor: '#FFFFFF'}}>
					<CardBody>
						<Row>
							<div className="col">
								<CardTitle tag="h5" className="text-uppercase text-muted mb-0">
									Gift Cards Available
								</CardTitle>
							</div>
						</Row>
						{props.cards.map(item =>
						{
							return <Row>
								<Col md={12} style={{fontSize: "12px"}}>
									<div className="ncentiva-gift-card-block small" style={{backgroundImage: `url('${cardTypeCtl.image(item.imageUuid, item.edited)}`}}/>
									<div>
										{item.productName} ({item.currency}) Value: {!!item.amount ? '$' + item.amount.toFixed(2) : `$${item.minAmount.toFixed(2)} - $${item.maxAmount.toFixed(2)}`}
									</div>
								</Col>
							</Row>;
						})}
					</CardBody>
				</div>
			</motion.div>
		</motion.div>
	);
};

export default BrandCard;